// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-portal-host {
  position: fixed;
  /* 1 million used because OF used it and the product has built around this number */
  z-index: 1000000;
}

.bolt-portal {
  overflow: hidden;
  pointer-events: none;
  z-index: 10;
}

/*# sourceMappingURL=Portal.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Portal/Portal.scss","webpack://./../azure-devops-ui/bin/Components/Portal/Portal.css"],"names":[],"mappings":"AAAA;EACI,eAAA;EAEA,mFAAA;EACA,gBAAA;ACAJ;;ADGA;EACI,gBAAA;EACA,oBAAA;EACA,WAAA;ACAJ;;AAEA,qCAAqC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
